<template>
  <svg
    width="2"
    height="48"
    viewBox="0 0 2 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M1 0V48" stroke="currentColor" />
  </svg>
</template>
